@switch (pageName) {
    @case (skeletonPage.Home) {
        <div class="sk-main-home-mobile">
            <div class="sk-center-content">
                <div class="sk-home-page-mobile">
                    <ms-skeleton-marquee />
                </div>
                <div class="sk-left-center">
                    <ms-skeleton-grid />
                </div>
            </div>
        </div>
    }
    @case (skeletonPage.UpComing) {
        <div class="sk-main-cal-mobile">
            <div class="sk-center-content">
                <div class="sk-left-center">
                    <ms-skeleton-grid />
                </div>
            </div>
        </div>
    }
    @case (skeletonPage.Favourites) {
        <div class="sk-main-cal-mobile sk-favt">
            <div class="sk-center-content">
                <div class="sk-left-center">
                    <ms-skeleton-grid />
                </div>
            </div>
        </div>
    }
    @case (skeletonPage.Competition) {
        <div class="sk-main-home-mobile">
            @for (c of [1, 2, 3, 4]; track c) {
                <div class="sk-competetion-mobile sk-top-events">
                    <div class="sk-top-sports sk-h-12 sk-b-rad8"></div>
                    <div class="sk-competition-first">
                        @for (top of [0, 1]; track top) {
                            <div class="sk-top-team sk-h-12 sk-b-rad8">
                                <div class="sk-circle"></div>
                                <div class="sk-top-players">
                                    <div class="sk-top-player1 sk-h-12 sk-b-rad8"></div>
                                    <div class="sk-top-player2 sk-h-12 sk-b-rad8"></div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
    @case (skeletonPage.Coupon) {
        <div class="sk-main-home-mobile">
            @for (c of [1, 2]; track c) {
                <div class="sk-competetion-mobile sk-top-events">
                    <div class="sk-top-sports sk-h-12 sk-b-rad8"></div>
                    <div class="sk-competition-first">
                        @for (top of [0, 1]; track top) {
                            <div class="sk-top-team sk-h-12 sk-b-rad8">
                                <div class="sk-circle"></div>
                                <div class="sk-top-players">
                                    <div class="sk-top-player1 sk-h-12 sk-b-rad8"></div>
                                    <div class="sk-top-player2 sk-h-12 sk-b-rad8"></div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
    @case (skeletonPage.Event) {
        <div class="sk-event-page-mobile">
            <ms-skeleton-events />
        </div>
    }
    @case (skeletonPage.Racing) {
        <div class="sk-main-home-mobile">
            <div class="sk-left-center">
                <div class="sk-mobile-horserace">
                    <div class="sk-nextrace-space">
                        @for (grid of [0, 1, 2]; track grid) {
                            <div class="sk-grid-first sk-p-12">
                                <div class="sk-grid-evets sk-h-12 sk-b-rad8"></div>
                                <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
                                <div class="sk-grid-markets">
                                    <div class="sk-grid-left">
                                        @for (grid of [0, 1, 2]; track grid) {
                                            <div class="sk-grid-teams">
                                                <div class="sk-grid-team1 sk-h-12 sk-b-rad8"></div>
                                                <div class="sk-grid-team2 sk-h-12 sk-b-rad8"></div>
                                            </div>
                                        }
                                    </div>
                                    <div class="sk-grid-right">
                                        @for (i of [0, 1, 2]; track i) {
                                            <div class="sk-grid-right-team sk-b-rad3"></div>
                                        }
                                    </div>
                                </div>
                                <div class="sk-line2 sk-h-12 sk-b-rad8"></div>
                            </div>
                        }
                    </div>
                    @for (region of [0, 1]; track region) {
                        <div class="sk-region">
                            @for (meeting of [0, 1, 2]; track meeting) {
                                <div class="sk-meeting">
                                    <div class="sk-grid-evets sk-h-12 sk-b-rad8"></div>
                                    <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    @case (skeletonPage.RacingTomorrow) {
        <div class="sk-main-home-mobile">
            <div class="sk-horse-tomorrow">
                @for (region of [0, 1, 2]; track region) {
                    <div class="sk-region">
                        @for (meeting of [0, 1, 2]; track meeting) {
                            <div class="sk-meeting">
                                <div class="sk-grid-evets sk-h-12 sk-b-rad8"></div>
                                <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
    @case (skeletonPage.RacingForecast) {
        <div class="sk-main-cal-mobile">
            <div class="sk-center-content">
                <div class="sk-left-center">
                    <ms-skeleton-grid />
                </div>
            </div>
        </div>
    }
}
